import { Text } from 'app/design/primitives/text';
import { Pressable } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

type OverallExperience = 'positive' | 'negative';

const overallButtonBaseStyle = {
  alignItems: 'center',
  borderColor: theme.colors['border.secondary'],
  borderRadius: 24,
  borderWidth: 1,
  flex: 1,
  justifyContent: 'center',
  minHeight: 48,
} as const;

const overallButtonIdleStyle = { backgroundColor: theme.colors.white } as const;

const overallButtonNegativeSelectedStyle = {
  backgroundColor: theme.colors['surface.error.subtle'],
  borderColor: theme.colors['surface.error.subtle'],
} as const;

const overallButtonPositiveSelectedStyle = {
  backgroundColor: theme.colors['surface.tertiary'],
  borderColor: theme.colors['surface.tertiary'],
} as const;

interface OverallButtonProps {
  emoji: string;
  onPress: () => void;
  selected: boolean;
  tone: OverallExperience;
}

export function OverallButton({ emoji, onPress, selected, tone }: OverallButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      style={[
        overallButtonBaseStyle,
        selected
          ? tone === 'positive'
            ? overallButtonPositiveSelectedStyle
            : overallButtonNegativeSelectedStyle
          : overallButtonIdleStyle,
      ]}
    >
      <Text fontSize={24}>{emoji}</Text>
    </Pressable>
  );
}
